/* ============================================================
   24GAMEKEYS — FEATURES MASTER JS  v4.0
   Cookie consent, Newsletter popup, Wishlist, Back to top,
   Sticky buy, Free shipping bar, Recently viewed, Preloader
   v4.0: fake social-proof popup and randomized viewer counter
   REMOVED permanently (EU UCPD/Omnibus — no fabricated customers,
   no fake urgency). Do not re-add.
   ============================================================ */
(function () {
  'use strict';

  /* ── UTILITIES ────────────────────────────────── */
  var ls = {
    get: function (k) { try { return localStorage.getItem(k); } catch(e) { return null; } },
    set: function (k, v) { try { localStorage.setItem(k, v); } catch(e) {} },
    del: function (k) { try { localStorage.removeItem(k); } catch(e) {} }
  };

  function el(sel, ctx) { return (ctx || document).querySelector(sel); }
  function els(sel, ctx) { return [...(ctx || document).querySelectorAll(sel)]; }
  function ready(fn) { document.readyState !== 'loading' ? fn() : document.addEventListener('DOMContentLoaded', fn); }

  /* ── PRELOADER ────────────────────────────────── */
  function initPreloader() {
    var loader = el('.gk-preloader');
    if (!loader) return;
    window.addEventListener('load', function () {
      setTimeout(function () {
        loader.classList.add('done');
        setTimeout(function () { loader.remove(); }, 600);
      }, 400);
    });
  }

  /* ── COOKIE CONSENT ─────────────────────────────── */
  function initCookieBanner() {
    if (ls.get('gk_cookie_ok')) return;
    var banner = el('.gk-cookie');
    if (!banner) return;
    setTimeout(function () { banner.classList.add('visible'); }, 1200);

    var accept = el('.gk-cookie__accept', banner);
    var decline = el('.gk-cookie__decline', banner);

    function dismiss(val) {
      ls.set('gk_cookie_ok', val);
      banner.style.transform = 'translateY(100%)';
      setTimeout(function () { banner.remove(); }, 400);
    }

    if (accept) accept.addEventListener('click', function () { dismiss('accepted'); });
    if (decline) decline.addEventListener('click', function () { dismiss('declined'); });
  }

  /* ── NEWSLETTER POPUP ───────────────────────────── */
  function initNewsletterPopup() {
    if (ls.get('gk_nl_seen')) return;
    var overlay = el('.gk-nl-overlay');
    if (!overlay) return;

    function close() {
      overlay.classList.remove('visible');
      ls.set('gk_nl_seen', '1');
    }

    setTimeout(function () { overlay.classList.add('visible'); }, 8000);

    var closeBtn = el('.gk-nl-close', overlay);
    var skipBtn  = el('.gk-nl-skip', overlay);
    if (closeBtn) closeBtn.addEventListener('click', close);
    if (skipBtn)  skipBtn.addEventListener('click', close);
    overlay.addEventListener('click', function (e) { if (e.target === overlay) close(); });

    var form = el('.gk-nl-modal form', overlay);
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var emailEl = form.querySelector('input[type=email]');
        var email = emailEl ? emailEl.value.trim() : '';
        if (!email) return;
        // Shopify newsletter subscription via /contact
        var body = new FormData();
        body.append('contact[email]', email);
        body.append('form_type', 'customer');
        fetch('/contact', { method: 'POST', body: body })
          .finally(function () {
            var inputWrap = el('.gk-nl-input-wrap', overlay);
            if (inputWrap) inputWrap.innerHTML = '<p style="font-family:var(--gw-font-b);font-size:0.9rem;color:var(--gw-green);text-align:center;padding:10px;">✅ Subscribed! Your discount code: <strong>WELCOME10</strong></p>';
            setTimeout(close, 3000);
          });
      });
    }
  }

  /* ── WISHLIST ─────────────────────────────────── */
  var wishlist = JSON.parse(ls.get('gk_wishlist') || '[]');

  function saveWishlist() { ls.set('gk_wishlist', JSON.stringify(wishlist)); }

  function isWishlisted(id) { return wishlist.indexOf(String(id)) !== -1; }

  function toggleWishlist(id, btn) {
    id = String(id);
    if (isWishlisted(id)) {
      wishlist = wishlist.filter(function (i) { return i !== id; });
      if (btn) { btn.classList.remove('active'); btn.title = 'Add to Wishlist'; }
    } else {
      wishlist.push(id);
      if (btn) { btn.classList.add('active'); btn.title = 'Remove from Wishlist'; }
    }
    saveWishlist();
    updateWishlistCount();
  }

  function updateWishlistCount() {
    els('[data-gk-wishlist-count]').forEach(function (el) {
      el.textContent = wishlist.length;
      el.style.display = wishlist.length ? '' : 'none';
    });
  }

  function initWishlistButtons() {
    els('[data-gk-wish]').forEach(function (btn) {
      var id = btn.dataset.gkWish;
      if (isWishlisted(id)) btn.classList.add('active');
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        toggleWishlist(id, btn);
      });
    });
    updateWishlistCount();
  }

  window.GK = window.GK || {};
  window.GK.wishlist = { toggle: toggleWishlist, isWishlisted: isWishlisted, getAll: function () { return wishlist; } };

  /* ── RECENTLY VIEWED ────────────────────────────── */
  function trackRecentlyViewed() {
    var pid = document.body.dataset.productId;
    if (!pid) return;
    var recent = JSON.parse(ls.get('gk_recent') || '[]');
    recent = recent.filter(function (id) { return id !== pid; });
    recent.unshift(pid);
    recent = recent.slice(0, 8);
    ls.set('gk_recent', JSON.stringify(recent));
  }

  /* ── BACK TO TOP ──────────────────────────────── */
  function initBackToTop() {
    var btn = el('.gk-back-top');
    if (!btn) return;
    window.addEventListener('scroll', function () {
      btn.classList.toggle('visible', window.scrollY > 400);
    }, { passive: true });
    btn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }

  /* ── STICKY BUY BUTTON ──────────────────────────── */
  function initStickyBuy() {
    var sticky = el('.gk-sticky-buy');
    var origBtn = el('.product-form__submit, button[name="add"]');
    if (!sticky || !origBtn) return;

    var observer = new IntersectionObserver(function (entries) {
      sticky.style.display = entries[0].isIntersecting ? 'none' : '';
    });
    observer.observe(origBtn);

    var stickyBtn = el('.gk-sticky-buy__btn', sticky);
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        origBtn.click();
        window.scrollTo({ top: origBtn.getBoundingClientRect().top + window.scrollY - 120, behavior: 'smooth' });
      });
    }

    var wishBtn = el('.gk-sticky-buy__wish', sticky);
    if (wishBtn) {
      var pid = document.body.dataset.productId;
      if (pid && isWishlisted(pid)) wishBtn.classList.add('active');
      wishBtn.addEventListener('click', function () {
        toggleWishlist(pid, wishBtn);
      });
    }
  }

  /* ── FREE SHIPPING PROGRESS BAR ───────────────────── */
  function initFreeShipBar() {
    var bars = els('.gk-free-ship');
    bars.forEach(function (bar) {
      var target    = parseFloat(bar.dataset.target || '50');
      var current   = parseFloat(bar.dataset.current || '0');
      var fill      = el('.gk-free-ship__fill', bar);
      var label     = el('[data-gk-ship-left]', bar);
      var pct       = Math.min(100, (current / target) * 100);

      if (fill) fill.style.width = pct + '%';

      if (label) {
        if (pct >= 100) {
          label.textContent = '🎉 Free shipping unlocked!';
          label.style.color = 'var(--gw-green)';
        } else {
          var left = (target - current).toFixed(2);
          label.textContent = 'Add $' + left + ' more for free shipping';
        }
      }
    });
  }

  /* ── COPY KEY BUTTON ────────────────────────────── */
  function initCopyButtons() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-gk-copy]');
      if (!btn) return;
      var target = document.getElementById(btn.dataset.gkCopy) || el(btn.dataset.gkCopy);
      var text   = target ? target.textContent.trim() : btn.dataset.gkCopyText;
      if (!text) return;

      navigator.clipboard.writeText(text).then(function () {
        var orig = btn.textContent;
        btn.textContent = '✓ Copied!';
        btn.style.background = 'var(--gw-green)';
        btn.style.color      = 'var(--gw-black)';
        setTimeout(function () {
          btn.textContent      = orig;
          btn.style.background = '';
          btn.style.color      = '';
        }, 2000);
      }).catch(function () {
        if (target) { var r = document.createRange(); r.selectNode(target); window.getSelection().addRange(r); }
      });
    });
  }

  /* ── NOTIFY ME FORM ─────────────────────────────── */
  function initNotifyMe() {
    els('.gk-notify form').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var email   = form.querySelector('input[type=email]').value.trim();
        var product = form.dataset.product || '';
        if (!email) return;
        var btn = form.querySelector('.gk-notify__btn');
        btn.textContent = '✓ Notified!';
        btn.style.background = 'var(--gw-green)';
        // Store locally — in production hook into back-in-stock email flow
        var notifs = JSON.parse(ls.get('gk_notifs') || '[]');
        notifs.push({ email: email, product: product, date: new Date().toISOString() });
        ls.set('gk_notifs', JSON.stringify(notifs));
      });
    });
  }

  /* ── ANNOUNCEMENT BAR AUTO-ROTATE ──────────────────── */
  function initAnnouncementRotate() {
    var msgs = els('.gk-ann-msg');
    if (msgs.length < 2) return;
    var current = 0;
    msgs.forEach(function (m, i) { m.style.display = i === 0 ? '' : 'none'; });
    setInterval(function () {
      msgs[current].style.display = 'none';
      current = (current + 1) % msgs.length;
      msgs[current].style.display = '';
    }, 4000);
  }

  /* ── PRODUCT IMAGE ZOOM ─────────────────────────── */
  function initImageHoverZoom() {
    els('.card__media img').forEach(function (img) {
      img.addEventListener('mouseenter', function () { this.style.transform = 'scale(1.08)'; });
      img.addEventListener('mouseleave', function () { this.style.transform = ''; });
    });
  }

  /* ── INIT ALL ─────────────────────────────────── */
  ready(function () {
    initPreloader();
    initCookieBanner();
    initNewsletterPopup();
    initWishlistButtons();
    initBackToTop();
    initStickyBuy();
    initFreeShipBar();
    initCopyButtons();
    initNotifyMe();
    initAnnouncementRotate();
    initImageHoverZoom();
    trackRecentlyViewed();
  });

})();
